import React from "react";
import { SocialAccountCard } from "./SocialAccountCard";
import { SiThreads } from "react-icons/si";

interface ThreadsAccountCardProps {
  account: {
    id: string;
    username?: string;
    name?: string;
    profile_picture_url?: string;
    connectionId: string;
  };
  onDisconnect?: (connectionId: string) => void;
}

export function ThreadsAccountCard({ account, onDisconnect }: ThreadsAccountCardProps) {
  const handleDisconnect = () => {
    if (onDisconnect) onDisconnect(account.connectionId);
  };

  const profilePictureUrl = account.profile_picture_url || undefined;

  return (
    <SocialAccountCard
      title={account.name || account.username || 'Threads User'}
      username={account.username}
      profilePictureUrl={profilePictureUrl}
      icon={<SiThreads />}
      onDisconnect={onDisconnect ? handleDisconnect : undefined}
    />
  );
}
